interface TermNotionLinkProps {
  termTitle: string | null;
  notionUrl: string | null;
}

/** ターム名を案件 Notion へのリンクとして表示する。URL が無ければテキストのまま出す */
export function TermNotionLink({ termTitle, notionUrl }: TermNotionLinkProps) {
  const label = termTitle || "-";

  if (!notionUrl) {
    return <span>{label}</span>;
  }

  return (
    <a
      href={notionUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[var(--color-primary-500)] underline"
    >
      {label}
    </a>
  );
}
